import React from "react";
import { CHARTS_TITLE } from "../consts";
import StepsIcon from '../assets/icons/steps.svg';
import CaloriesIcon from '../assets/icons/calories.svg';
import SleepIcon from '../assets/icons/sleep.svg';
export default function ChartBox({ type, configurations, isPdf }) {
    const wellness = ['calories', 'steps', 'sleep'];
    const wellnessImages = {
        steps: StepsIcon,
        calories: CaloriesIcon,
        sleep: SleepIcon,
    };
    const getWellnessTemplate = () => {
        //render wellness head just once
        if (!configurations[type]
            || (type !== 'calories' && configurations['calories'])
            || (type === 'sleep' && configurations['steps'])) {
            return;
        }
        return (React.createElement("div", { id: "wellness-charts", className: 'card page-break' },
            React.createElement("div", { className: "bg-transparent card-header" },
                React.createElement("div", { className: "row header-card" },
                    React.createElement("div", { className: "col-xs-auto" }, "Wellness"))),
            React.createElement("div", { className: "wellness" },
                React.createElement("div", { className: "red-color" }),
                React.createElement("div", { className: "blue-color" }),
                React.createElement("div", { className: "green-color" }),
                React.createElement("div", { className: "yellow-color" }))));
    };
    return (React.createElement(React.Fragment, null, wellness.includes(type) && configurations[type] ?
        React.createElement("div", { className: 'pdf-cut-guard' },
            getWellnessTemplate(),
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "title-icon-container" },
                    React.createElement("img", { width: 40, src: wellnessImages[type], alt: 'wellness icon' }),
                    React.createElement("div", { className: "title" }, CHARTS_TITLE[type])),
                React.createElement("div", { className: "line-divide" })),
            React.createElement("div", { className: "card-body" },
                React.createElement("div", { className: `${type}-chart`, style: { width: '100%' } }))) : (configurations[type.replace('-', '_').toLowerCase()]) &&
        React.createElement("div", { className: `card` },
            React.createElement("div", { className: "bg-transparent card-header" }, type === 'hrv_lfhf' && configurations['hrv_pr'] ?
                ''
                :
                    React.createElement("div", { className: "row header-card" },
                        React.createElement("div", { className: "col-xs-auto" }, CHARTS_TITLE[type]))),
            React.createElement("div", { className: "card-body" },
                React.createElement("div", { className: `${type}-chart pb-2`, style: { width: '100%' } })))));
}
